import { schema } from "normalizr"

export const feedbackSchema = new schema.Entity("feedbacks")
